import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Telehealth from "@/pages/Telehealth";
import Training from "@/pages/Training";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import LegacyRedirect from "@/pages/LegacyRedirect";
import { AcknowledgementGate } from "@/components/AcknowledgementGate";
import { ChatWidget } from "@/components/ChatWidget";
import { SessionTimeout } from "@/components/SessionTimeout";
import { SaleBanner } from "@/components/SaleBanner";
import { PromoPopup } from "@/components/PromoPopup";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AcknowledgementGate />
            <SaleBanner />
            <Header />
            <CartDrawer />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/product-page/:slug" element={<LegacyRedirect />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/telehealth" element={<Telehealth />} />
                <Route path="/training" element={<Training />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <ChatWidget />
            <SessionTimeout />
            <PromoPopup />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
